jQuery(function($){
    $('.js-scroll-wrapper').each(function(){
        var $wrapper    = $(this),
            $content    = $wrapper.find('.js-scroll-content'),
            $leftArrow  = $wrapper.find('.js-arrow-left'),
            $rightArrow = $wrapper.find('.js-arrow-right'),
            isDown      = false,
            startX      = 0,
            scrollStart = 0,
            scrollInterval;

        // pomocná na update šípok
        function updateArrows(){
            var maxScroll = $content[0].scrollWidth - $content.outerWidth();
            $leftArrow.toggleClass('disabled', $content.scrollLeft() <= 0);
            $rightArrow.toggleClass('disabled', $content.scrollLeft() >= maxScroll);
        }

        // DRAG‑TO‑SCROLL
        $content
            .on('mousedown', function(e){
                isDown = true;
                $content.addClass('dragging');
                startX = e.pageX - $content.offset().left;
                scrollStart = $content.scrollLeft();
                e.preventDefault();
            });

        $(document)
            .on('mousemove', function(e){
                if (!isDown) return;
                var x = e.pageX - $content.offset().left,
                    walk = (x - startX);
                $content.scrollLeft(scrollStart - walk);
                updateArrows();
            })
            .on('mouseup mouseleave', function(){
                if (isDown) {
                    isDown = false;
                    $content.removeClass('dragging');
                }
            });

        // ARROW SCROLL
        function startScroll(dir){
            if ((dir<0 && $leftArrow.hasClass('disabled')) ||
                (dir>0 && $rightArrow.hasClass('disabled'))) return;
            scrollInterval = setInterval(function(){
                $content.scrollLeft($content.scrollLeft() + dir * 20);
                updateArrows();
            }, 30);
        }
        function stopScroll(){
            clearInterval(scrollInterval);
        }

        $leftArrow
            .on('mousedown', function(){ startScroll(-1); })
            .on('mouseup mouseleave', stopScroll);

        $rightArrow
            .on('mousedown', function(){ startScroll(1); })
            .on('mouseup mouseleave', stopScroll);

        // init
        updateArrows();
    });
});
